import type { MapDispatchToPropsFunction, MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { selectedBatchFormsDeletedThunk } from 'state/batchForm/batchForm.thunks';
import { getIsDeleteFormConfirmationModalOpen, getNumberOfFormsSelectedInBatchTab } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { batchToggleDeleteFormConfirmationModal } from 'state/workspaces/batch/tabContent/tabContent.actions';

export type DeleteFormConfirmationModalStateProps = {
  isDeleteFormConfirmationModalOpen: boolean;
  nbOfFormsSelected: number;
};
export type DeleteFormConfirmationModalOwnProps = {
  tabId: string;
};

export type DeleteFormConfirmationModalDispatchProps = {
  onConfirm: () => void;
  onClose: () => void;
};

export type DeleteFormConfirmationModalProps = DeleteFormConfirmationModalStateProps &
  DeleteFormConfirmationModalOwnProps &
  DeleteFormConfirmationModalDispatchProps;

export const mapStateToProps: MapStateToProps<
  DeleteFormConfirmationModalStateProps,
  DeleteFormConfirmationModalOwnProps,
  AppState
> = (state: AppState, { tabId }: DeleteFormConfirmationModalOwnProps): DeleteFormConfirmationModalStateProps => {
  const isDeleteFormConfirmationModalOpen = getIsDeleteFormConfirmationModalOpen(state, tabId);
  const nbOfFormsSelected = getNumberOfFormsSelectedInBatchTab(state, tabId);
  return {
    isDeleteFormConfirmationModalOpen,
    nbOfFormsSelected,
  };
};

export const mapDispatchToProps: MapDispatchToPropsFunction<
  DeleteFormConfirmationModalDispatchProps,
  DeleteFormConfirmationModalOwnProps
> = (
  dispatch: ThunkDispatch,
  { tabId }: DeleteFormConfirmationModalOwnProps,
): DeleteFormConfirmationModalDispatchProps => ({
  onConfirm() {
    dispatch(selectedBatchFormsDeletedThunk(tabId));
    dispatch(batchToggleDeleteFormConfirmationModal(tabId, false));
  },
  onClose() {
    dispatch(batchToggleDeleteFormConfirmationModal(tabId, false));
  },
});

export const connectDeleteFormConfirmationModal = connect<
  DeleteFormConfirmationModalStateProps,
  DeleteFormConfirmationModalDispatchProps,
  DeleteFormConfirmationModalOwnProps,
  AppState
>(mapStateToProps, mapDispatchToProps);
